<!--
 * @Author: zenghong zenghong@edsz9.com
 * @Date: 2022-08-17 10:21:35
 * @LastEditors: zenghong zenghong@edsz9.com
 * @LastEditTime: 2022-08-17 11:20:08
 * @FilePath: \client-portal\src\views\apps\home\accountItem.vue
-->
<template>
  <div class="account-item-box">
      <el-row>
        <div class="card-base card-shadow--small home-form account-info">
          <h2 class="account-info-title">
            <span >{{$t('tradeAccountType.'+accountList[0].tradeAccountType)}}</span>
            <el-tooltip v-if="curAccountInfo.isDormant" popper-class="account-tip" effect="dark"  :content="$t('accountInfo.accountDormant', {accountNumber: curAccountInfo.tradeAccountNumber})" placement="top-start" >
              <span class="what-dormant" >?</span>
            </el-tooltip>
            <span class="account-status" v-if="curAccountInfo.isDormant ">{{$t('common.dormant ')}}</span>
          </h2>
          <el-row class="flex-row">
            <el-col :span="12" class="left">
              {{$t('home.accountNo')}}
            </el-col>
            <el-col :span="12" class="right">
              <span v-if="accountList.length===1">{{accountList[0].tradeAccountNumber}}</span>
              <el-select v-else v-model="num" @change="changeHandle">
                <el-option v-for="val in accountList" :key="val.tradeAccountNumber" :value="val.tradeAccountNumber">{{val.tradeAccountNumber}}</el-option>
              </el-select>
            </el-col>
          </el-row>
          <div class="text-center money" v-show="selectItem.moneyList && selectItem.moneyList.length">
            <div class="balance" v-for="(el, elIndex) in selectItem.moneyList" :key="elIndex">
              <div class="balance-title">{{el.amountDescribe}}</div>
              <div class="curBalance">{{isNaN(el.totalBalance) ? el.totalBalance : financial(el.totalBalance, el.currency)}}</div>
            </div>
          </div>
          <el-row class="flex-row row-bottom">
            <el-col :span="12" class="left">
              {{$t('home.currency')}}
            </el-col>
            <el-col :span="12" class="right">
              {{selectItem.base_currency}}
            </el-col>
          </el-row>
          <el-row class="flex-row row-bottom">
            <el-col :span="12" class="left">
              {{$t('home.enabled')}}
            </el-col>
            <el-col :span="12" class="right">
              <span v-if="selectItem.status === 'STOP'">{{$t('home.enabled_false')}}</span>
              <span v-else-if="selectItem.status === 'OPEN'">{{$t('home.enabled_true')}}</span>
              <span v-else-if="selectItem.status === 'CLOSE'">{{$t('home.enabled_close')}}</span>
            </el-col>
          </el-row>
        </div>
      </el-row>
  </div>
</template>

<script>

export default {
  props: {
    accountList: {
      type: Array,
      default: () => []
    },
    selectItem: {
      type: Object,
      default: () => {}
    },
    typeKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      num: '',
      curAccountInfo: {},
      show: true
    }
  },
  watch: {
    selectItem: {
      handler(val) {
        this.num = val.tradeAccountNumber
        this.curAccountInfo = this.selectItem
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    console.log(this.curAccountInfo, 'this.curAccountInfo')
    if (this.accountList.length === 1) {
      this.curAccountInfo = this.accountList[0]
    } else {
      this.curAccountInfo = this.selectItem
    }
  },
  methods: {
    changeHandle(val) {
      this.$emit('changeHandle', val, this.typeKey)
    },
    financial (x, currency) {
      let amount = this.Util.formatCurrency(x)
      return `${currency} ${amount}`
    }
  }

}
</script>

<style lang="scss" scoped>
.account-info {
  height: 440px !important;
}
.flex-row{
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.row-bottom{
  padding-bottom: 16px;
  border-bottom: 1px solid #E2E2E2;
}
.money {
  border: 10px solid #eee;
  margin-bottom: 22px;
  // padding: 15px 0;
  .balance {
    border-bottom: 6px solid #eee;
    padding: 15px 0;
    &:last-of-type{
      border-bottom: 0;
    }
  }
  .balance-title {
    font-family: Muli-Bold;
    font-size: 12px;
    color: #666666;
    text-align: center;
  }
  .curBalance {
    font-family: Muli-Bold;
    font-size: 22px;
    color: #24282d;
    letter-spacing: 0.27px;
    text-align: center;
  }
}
.account-info-title {
  font-family: Muli-Bold;
  font-size: 18px !important;
  color: #182a54 !important;
  letter-spacing: 0.22px;
  border-bottom: 3px solid #ebebeb;
  padding: 10px 5px 20px;
}
.account-status{
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #24282D;
  background: #F3F4F6;
  padding: 5px 10px;
  border-radius: 5px;
}
.what-dormant{
 margin-left: 10px;
 cursor: pointer;
}

</style>
<style lang="scss" >
.account-tip{
  width: 400px;
}
</style>
